import { render, staticRenderFns } from "./op-logistics-provider-modal.vue?vue&type=template&id=2fd0a158&scoped=true&"
import script from "./op-logistics-provider-modal.vue?vue&type=script&lang=js&"
export * from "./op-logistics-provider-modal.vue?vue&type=script&lang=js&"
import style0 from "./op-logistics-provider-modal.vue?vue&type=style&index=0&id=2fd0a158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0a158",
  null
  
)

export default component.exports